import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ParticipantService from "../../services/srv-participants/ParticipantService";
import { ParticipantForm } from "../../containers/Event/Participants/ParticipantForm";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";
import AdminService from "../../services/srv-admin/AdminService";

function ParticipantInfo(props) {
  const { id } = useParams();
  const [eventParticipant, setEventParticipant] = useState({});
  const [data, setData] = useState({});
  const [loading, setLoading] = useState({});

  useEffect(() => {
    setLoading(true);
    getEventParticipant();
  }, []);

  function getEventParticipant() {
    ParticipantService.getEventParticipant(id).then((data) => {
      setEventParticipant(data);
      if (data.email) {
        AdminService.getLanguage(data.email).then(() => {
          ParticipantService.getEventParticipantFieldsByEventId(
            data.etkinliK_TANIM_ID
          ).then((fieldData) => {
            setData(fieldData);
            setLoading(false);
          });
        });
      }
    });
  }

  return (
    <Fragment>
      {loading ? (
        <LoadingPanel />
      ) : (
        <ParticipantForm
          eventParticipant={eventParticipant}
          data={data}
        ></ParticipantForm>
      )}
    </Fragment>
  );
}

export { ParticipantInfo };
